import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const EditLabDetails = ({ labDetails = {}, onChange, onSubmit, isAdmin = false }) => {
  const [localLabDetails, setLocalLabDetails] = useState({
    labName: "",
    address: "",
    address2: "",
    country: "",
    city: "",
    telephone: "",
    utc: "",
    stateProvince: "",
    zipCode: "",
    email: "",
    subdomain: "",
  });

  const [loading, setLoading] = useState(false);

  // Update local state when labDetails prop changes (from parent)
  useEffect(() => {
    if (labDetails && Object.keys(labDetails).length > 0) {
      setLocalLabDetails({
        labName: labDetails.labName || "",
        address: labDetails.address || "",
        address2: labDetails.address2 || "",
        country: labDetails.country || "",
        city: labDetails.city || "",
        telephone: labDetails.telephone || "",
        utc: labDetails.utc || labDetails.timeZone || "",
        stateProvince: labDetails.stateProvince || labDetails.state || "",
        zipCode: labDetails.zipCode || labDetails.zipPostal || "",
        email: labDetails.email || labDetails.labEmail || "",
        subdomain: labDetails.subdomain || "",
      });
    }
  }, [labDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedDetails = {
      ...localLabDetails,
      [name]: value
    };
    setLocalLabDetails(updatedDetails);
    
    if (onChange) {
      onChange(updatedDetails);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Email validation - only if email is provided
    if (localLabDetails.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(localLabDetails.email)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Email",
          text: "Please enter a valid email address!",
          confirmButtonColor: "#004aad",
        });
        return;
      }
    }

    if (onSubmit) {
      setLoading(true);
      await onSubmit({ labDetails: localLabDetails });
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: "20px" }}>
        <h1 style={{ marginBottom: "10px"}}>
          Lab Details
        </h1>
      <div
        style={{
          border: "1px solid #e9ecef",
          borderTop: "3px solid #004aad",
          backgroundColor: "#e9ecef",
          padding: "10px",
          borderRadius: "4px",
        }}
      >

        <form onSubmit={handleSubmit}>
          <div style={{ padding: "10px", borderRadius: "4px" }}>
            
            {/* Lab Name - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Lab Name
              </label>
              <input
                type="text"
                name="labName"
                value={localLabDetails.labName}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* Address - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Address
              </label>
              <input
                type="text"
                name="address"
                value={localLabDetails.address}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* Address 2 (Optional) */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Address 2 <span style={{ color: "#999", fontSize: "12px" }}>(Optional)</span>
              </label>
              <input
                type="text"
                name="address2"
                value={localLabDetails.address2}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* Country - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Country
              </label>
              <input
                type="text"
                name="country"
                value={localLabDetails.country}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* City - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                City
              </label>
              <input
                type="text"
                name="city"
                value={localLabDetails.city}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* State / Province - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                State / Province
              </label>
              <input
                type="text"
                name="stateProvince"
                value={localLabDetails.stateProvince}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* Zip / Postal Code - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Zip / Postal Code
              </label>
              <input
                type="text"
                name="zipCode"
                value={localLabDetails.zipCode}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            {/* Telephone - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Telephone
              </label>
              <input
                type="tel"
                name="telephone"
                value={localLabDetails.telephone}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
                placeholder="e.g., +1 234 567 8900"
              />
            </div>

            {/* UTC - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                UTC
              </label>
              <input
                type="text"
                name="utc"
                value={localLabDetails.utc}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
                placeholder="e.g., UTC+5"
              />
            </div>

            {/* Email - Optional */}
            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                Lab Email
              </label>
              <input
                type="email"
                name="email"
                value={localLabDetails.email}
                onChange={handleInputChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  width: "60%",
                  backgroundColor: "#fff",
                }}
                placeholder="lab@example.com"
              />
            </div>

            {/* Subdomain - Only for Admin */}
            {isAdmin && (
              <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                <label style={{ fontWeight: "bold", marginLeft: "10px", width: "30%", color: "#333" }}>
                  Subdomain
                </label>
                <input
                  type="text"
                  name="subdomain"
                  value={localLabDetails.subdomain}
                  onChange={handleInputChange}
                  style={{
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    width: "60%",
                    backgroundColor: "#fff",
                  }}
                  placeholder="e.g., mylab"
                />
                <small style={{ marginLeft: "10px", color: "#666" }}>.yourdomain.com</small>
              </div>
            )}
          </div>

          {/* Save Button */}
          <div className="mt-3" style={{ textAlign: "right", marginTop: "15px" }}>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ marginRight: "20px", backgroundColor: "#004aad", borderColor: "#004aad" }}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Lab Details"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLabDetails;